module.exports = __webpack_public_path__ + "static/media/package-corporate.481f3486.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/img/package-corporate.svg
// module id = 126
// module chunks = 0